import {AdGroupBean} from 'common/api/api'
import React from 'react'
import {DictionarySelector, DictionarySelectorProps, enumValueToLabelValue} from './DictionarySelector'
import DeviceTypesEnum = AdGroupBean.DeviceTypesEnum

export const DeviceTypeSelector: React.FC<DictionarySelectorProps> = (props) =>
    <DictionarySelector {...props} cacheKey="deviceType" mode="multiple" loader={() => enumValueToLabelValue([
        DeviceTypesEnum.Desktop,
        DeviceTypesEnum.Mobile,
        DeviceTypesEnum.Tablet,
        DeviceTypesEnum.ConnectedTV,
        DeviceTypesEnum.ConnectedDevice,
        DeviceTypesEnum.SetTopBox,
        DeviceTypesEnum.OOHDevice,
        ]
    )}/>